import moment from "moment";
import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { FeriadoService } from "../../../services/FeriadoService";

export default {
  name: "AtribuirFeriados",

  components: {
    TextField,
    SelectField,
  },

  data: () => ({
    form: {},
    page: 1,
    pageCount: 0,
    textButton: 'Incluir',

    headers: [
      { text: "Feriado", value: "nome", width: 700, sortable: false },
      { text: "Data", value: "data", width: 300, sortable: false },
      { text: "Ações", value: "actions", sortable: false },
    ],
    items: [],
    filter: {
      anos: 2024
    },
    options: {
      anos:[],
    },

    loading: {
      table: false,
      btn: false,
    }
  }),

  beforeMount() {
    this.getFeriados();
    this.getAnos();
  },

  filters: {
    localeDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    localeDateDayMonth(date) {
      return moment(date).format("DD/MM");
    }
  },

  methods: {
    async search (anos = null) {
      this.page = 1;
      this.getFeriados(anos);
    },
    async getAnos(){
      const response = await FeriadoService.getAnos();

      this.options.anos = response.map((el) => {
        return {
          text: el,
          value: el,
        };
      });

      this.options.anos?.unshift({ text: "Selecione", value: "" });
    },

    async getFeriados(anos = null) {
      this.loading.table = true;

      if (this.filter.anos) {
        anos = this.filter.anos;
      }

      const response = await FeriadoService.getFeriados(anos);
      this.items = response;
      this.pageCount = Math.ceil((this.items.length - 1) / 10);
      this.loading.table = false;
    },

    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        formData.append("nome", this.form.nomeFeriado);
        formData.append("data", moment(this.form.dataFeriado).format("YYYY-MM-DD"));
        if (this.textButton == 'Editar') {
          formData.append("id", this.form.id);
          return this.editFeriado(this.form.id, formData);
        }

        return this.createFeriado(formData);

      }
      return SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    cancelForm() {
      this.textButton = 'Incluir';
      this.form.nomeFeriado = null;
      this.form.nomeFeriado = null;
      this.form.dataFeriado = null;
    },

    async editFeriado(id, formData) {
      this.loading.btn = true;
      const response = await FeriadoService.putFeriado(id, formData);
      if (response) {
        this.$refs.form.reset();
      }
      this.loading.btn = false;
      this.cancelForm();
      this.getFeriados();
    },

    async createFeriado(formData) {
      this.loading.btn = true;
      const response = await FeriadoService.postFeriado(formData);
      if (response) {
        this.$refs.form.reset();
      }
      this.loading.btn = false;
      this.getFeriados();
    },

    async deleteFeriado(id) {
      this.loading.table = true;
      await FeriadoService.deleteFeriado(id);
      this.getFeriados();
      this.loading.table = false;
    },

    prepareFormEdit(id, data, nome) {
      this.form.id = id;
      this.form.nomeFeriado = nome;
      this.form.dataFeriado = data;
      this.textButton = 'Editar';
    },
  },
};